import React from 'react';
import Helmet from 'react-helmet';
import { Banner, Grid, Table, PageSection, Row, Col } from '../components';
import Layout from '../layouts/layout';

import cennikImg from '../assets/img/cennik.jpg';
import cennik from '../assets/illustrations/cennik.svg';

const cols = ['', 'trvanie', 'dĺžka hodiny', 'cena'];

const rowsMovement = [
  ['Individuálna hodina', 'jednorázová', '60 minút', '40 EUR'],
  ['Individuálne hodiny', '8 tréningov / 1 mesiac', '60 minút', '288 EUR'],
  ['', '12 tréningov / 1 mesiac', '60 minút', '408 EUR'],
  ['Kurz [tematický]', '8 tréningov / 1 mesiac', '60 minút', '60 EUR'],
  ['Skupinová hodina', 'jednorázová', '60 minút', '10 EUR'],
  ['', '4 hodiny', '60 minút', '32 EUR'],
  ['', '8 hodín', '60 minút', '56 EUR'],
];

const rowsPortDeBras = [
  ['Otvorená hodina', 'Jednorázová', '60 minút', '6 EUR'],
  ['Kurz', '8 hodín', '60 minút', '48 EUR'],
];

const rowsLudoveTanceDeti = [
  ['Otvorená hodina', 'Jednorázová', '60 minút', '5 EUR'],
  ['Kurz', '8 hodín', '60 minút', '40 EUR'],
];

const rowsLudoveTanceDospeli = [
  ['Otvorená hodina', 'Jednorázová', '60 minút', '6 EUR'],
  ['Kurz', '8 hodín', '60 minút', '48 EUR'],
];

const rowsAerialSilksHoop = [
  ['Individuálna hodina', 'Jednorázová', '60 minút', '30 EUR'],
  ['Otvorená hodina *', 'Jednorázová', '60 minút', '12 EUR'],
  ['Kurz **', '8 hodín', '60 minút', '80 EUR'],
];

const rowsLatinoLadies = [
  ['Otvorená hodina', 'Jednorázová', '60 minút', '6 EUR'],
  ['Kurz', '8 hodín', '60 minút', '48 EUR'],
];

const rowsSpolocenskeTance = [
  ['Individuálna ProAm', 'Jednorázová', '45 minút', '48 EUR'],
  [
    'Kurz latinsko-amerických tancov pre páry',
    '10 týždňov',
    '',
    '200 EUR - pár',
  ],
];

const CennikPage = () => (
  <Layout type="transparent">
    <Helmet title={`Adrian Bartalos | Cenník`}>
      <meta property="og:image" content={cennikImg} />
      <meta property="og:title" content={`Adrian Bartalos | Cenník`} />
    </Helmet>
    <Banner
      bgUrl={cennikImg}
      svg={cennik.id}
      fullWidth
      overlay
      fitContent="s"
    />
    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Movement</h2>
            <Table cols={cols} rows={rowsMovement} className="mb-xlarge" />
            <p>
              <span className="text-color-brick">
                <strong>Poznámka:</strong> Po zaplatení je doba vyčerpania
                predplatených hodín stanovená na 1 mesiac.
              </span>
            </p>
          </Col>
        </Row>
      </Grid>
    </PageSection>

    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Spoločenské tance</h2>
            <Table cols={cols} rows={rowsSpolocenskeTance} />
          </Col>
        </Row>
      </Grid>
    </PageSection>

    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Port de Bras</h2>
            <Table cols={cols} rows={rowsPortDeBras} />
          </Col>
        </Row>
      </Grid>
    </PageSection>

    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Ľudové tance pre deti</h2>
            <Table cols={cols} rows={rowsLudoveTanceDeti} />
          </Col>
        </Row>
      </Grid>
    </PageSection>

    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Ľudové tance pre dospelých</h2>
            <Table cols={cols} rows={rowsLudoveTanceDospeli} />
          </Col>
        </Row>
      </Grid>
    </PageSection>

    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Aerial Silks/Hoop</h2>
            <Table
              cols={cols}
              rows={rowsAerialSilksHoop}
              className="mb-xlarge"
            />

            <p>
              <span className="text-color-brick">
                * Žiadna viazanosť na kurz.
              </span>
              <br />
              <span className="text-color-brick">
                ** Jednu vynechanú hodinu v kurze je možné bezplatne nahradiť.
              </span>
            </p>
          </Col>
        </Row>
      </Grid>
    </PageSection>

    <PageSection type="beige">
      <Grid>
        <Row>
          <Col xs={12}>
            <h2 className="h1 text-center">Latino Ladies</h2>
            <Table cols={cols} rows={rowsLatinoLadies} />
          </Col>
        </Row>
      </Grid>
    </PageSection>
  </Layout>
);

export default CennikPage;
